/* eslint-disable jsx-a11y/anchor-is-valid */
import React, { useState, useEffect } from "react";
import axios from "axios";

import DeliverySearch from "../../components/deliverys/DeliverySearch";
import DeliverySearchResult from "../../components/deliverys/DeliverySearchResult";
import DeliverySearchEmptyResult from "../../components/deliverys/DeliverySearchEmptyResult";
import HeaderTitle from "../../components/includes/HeaderTitle";

import Paging from "../../components/includes/Paging";
import {
  isNull,
  LoginAfterCheckLogin,
  ChangeDateStringOnlyDate,
  RemakeAddress,
  addThousandPoint,
  ChangeMobileFormat,
  ShowDeliveryStatus,
  ChangeReceiptPayment,
} from "../../../components/common/Common";

/* css */
import "../../../css/admin_layout.css";
import "../../../css/admin.css";

//직원 관리
const DeliveryList = ({ setMenuType, setMenuItem }) => {
  LoginAfterCheckLogin(0); //로그인 상태 점검
  //컬럼상태
  const headerString = localStorage.getItem("deliveryHeaders");

  //컬럼기본
  let columnList = [
    { Header: "배차등록자", accessor: "data1", width: 100 },
    { Header: "상차일", accessor: "data2", width: 100 },
    { Header: "하차일", accessor: "data3", width: 100 },
    { Header: "상차지", accessor: "data4", width: 300 },
    { Header: "하차지", accessor: "data5", width: 300 },
    { Header: "거래처코드", accessor: "data6", width: 170 },
    { Header: "거래처명", accessor: "data7", width: 170 },
    { Header: "차량번호", accessor: "data8", width: 270, isEditable: true },
    { Header: "배차기사", accessor: "data9", width: 80 },
    { Header: "배차담당자", accessor: "data28", width: 100 },
    { Header: "운임료(원)", accessor: "data10", width: 90 },
    { Header: "인수증 결제방법", accessor: "data11", width: 130 },
    { Header: "입금여부", accessor: "data29", width: 90 },
    { Header: "인수증", accessor: "data12", width: 60 },
    { Header: "요청톤", accessor: "data13", width: 70 },
    { Header: "상품", accessor: "data14", width: 180 },
    { Header: "수량", accessor: "data15", width: 70 },
    { Header: "운행량(Km)", accessor: "data16", width: 90 },
    { Header: "수수료율(%)", accessor: "data17", width: 110 },
    { Header: "실운행가(원)", accessor: "data18", width: 100 },
    { Header: "지급원가(원)", accessor: "data27", width: 100 },
    { Header: "유의사항", accessor: "data19", width: 250 },
    { Header: "전자전표", accessor: "data20", width: 80 },
    { Header: "기사연락처", accessor: "data21", width: 150 },
    { Header: "상태", accessor: "data22", width: 80 },
    { Header: "실적신고", accessor: "data26", width: 80 },
    { Header: "관리자메모", accessor: "data23", width: 400 },
    { Header: "고유번호", accessor: "data24", width: 20 },
    { Header: "선택유무", accessor: "data25", width: 20 },
  ];
  const [varColumnLists, setColumnLists] = useState([]);

  //배차목록
  const [varDeliveryLists, setDeliveryLists] = useState([]);

  //페이지
  const [varTotalCount, setTotalCount] = useState(0);
  const [varPageSize, setPageSize] = useState(500);
  const [varPageNum, setPageNum] = useState(1);
  const [varMaxNumPage, setMaxNumPage] = useState(0);

  const [varDeliveryFee, setDeliveryFee] = useState(0);
  const [varDriverFee, setDriverFee] = useState(0);

  const [isLoading, setIsLoading] = useState(false);
  const [excelData, setExcelData] = useState([]);

  //검색
  const [varSearchData, setSearchData] = useState({
    sdate: null,
    edate: null,
    searchTermMode: 0,
    searchOption: "all",
    searchString: "",
  });

  //배차현황목록 읽어오기
  const getDeliveryList = async () => {
    // 두 번째 API 호출
    setIsLoading(true);
    const excelSendData = {
      pageNum: "1",
      pageSize: 0,
      searchData: varSearchData,
    };

    await axios
      .post(
        `${process.env.REACT_APP_HOST}/admin_get_delivery_list`,
        excelSendData
      )
      .then((res) => {
        const datas = res.data;
        if (datas.retvalue === 1) {
          let excelArray = [];
          if (datas.results?.length > 0) {
            const dataDelivery = datas.results;
            for (var i = 0; i < dataDelivery.length; i++) {
              const lineObj = dataDelivery[i];
              var newData = {};
              newData["data1"] = lineObj.admin_name;
              newData["data2"] = ChangeDateStringOnlyDate(
                lineObj.dc_riding_date
              );
              newData["data3"] = ChangeDateStringOnlyDate(lineObj.dc_quit_date);
              newData["data4"] = RemakeAddress(lineObj.dc_riding_address, 3);
              newData["data5"] = RemakeAddress(lineObj.dc_quit_address, 3);
              newData["data6"] = lineObj.cs_code;
              newData["data7"] = lineObj.cs_name;
              newData["data8"] = lineObj.dr_carnumb;
              newData["data9"] = lineObj.driver_name;
              newData["data10"] = addThousandPoint(lineObj.dc_price);
              newData["data11"] = ChangeReceiptPayment(
                lineObj.dc_receipt_payment
              );
              newData["data12"] =
                lineObj.dc_receipt_image === 1
                  ? "등록"
                  : lineObj.dc_receipt_image === -1
                  ? "없음"
                  : "미등록";
              newData["data13"] = lineObj.dc_prd_req_ton;
              newData["data14"] = lineObj.dc_prd_name;
              newData["data15"] = lineObj.dc_prd_quantity;
              newData["data16"] = lineObj.dc_volume;
              newData["data17"] = addThousandPoint(lineObj.dc_charge);
              newData["data18"] = addThousandPoint(lineObj.dc_rprice);
              newData["data19"] = lineObj.dc_prd_notice;
              newData["data20"] = lineObj.dc_prd_slip === 1 ? "Y" : "N";
              newData["data21"] = ChangeMobileFormat(lineObj.driver_mobile);
              newData["data22"] = ShowDeliveryStatus(lineObj.dc_status);
              newData["data23"] = lineObj.dc_admin_memo;
              newData["data24"] = lineObj.dc_idx;
              newData["data25"] = 0;
              newData["data26"] = lineObj.dc_reported === 0 ? "미신고" : "신고";
              newData["data27"] = addThousandPoint(lineObj.dc_dprice);
              newData["data28"] = lineObj.staff_name;
              newData["data29"] = lineObj.dc_paid === 1 ? "입금" : "미입금";
              excelArray.push(newData);
            }
          }
          setExcelData(excelArray);
        } else {
          setExcelData([]);
          setIsLoading(false);
        }
      });

    // 첫 번째 API 호출
    const sendData = {
      pageNum: varPageNum,
      pageSize: varPageSize,
      searchData: varSearchData,
    };

    await axios
      .post(`${process.env.REACT_APP_HOST}/admin_get_delivery_list`, sendData)
      .then((res) => {
        const datas = res.data;
        if (datas.retvalue === 1) {
          setTotalCount(datas.totalcount);
          setDeliveryFee(datas.deliveryfee);
          setDriverFee(datas.driverfee);
          let newArray = [];
          if (datas.results?.length > 0) {
            const dataDelivery = datas.results;
            for (var i = 0; i < dataDelivery.length; i++) {
              const lineObj = dataDelivery[i];
              var newData = {};
              newData["data1"] = lineObj.admin_name;
              newData["data2"] = ChangeDateStringOnlyDate(
                lineObj.dc_riding_date
              );
              newData["data3"] = ChangeDateStringOnlyDate(lineObj.dc_quit_date);
              newData["data4"] = RemakeAddress(lineObj.dc_riding_address, 3);
              newData["data5"] = RemakeAddress(lineObj.dc_quit_address, 3);
              newData["data6"] = lineObj.cs_code;
              newData["data7"] = lineObj.cs_name;
              newData["data8"] = lineObj.dr_carnumb;
              newData["data9"] = lineObj.driver_name;
              newData["data10"] = addThousandPoint(lineObj.dc_price);
              newData["data11"] = ChangeReceiptPayment(
                lineObj.dc_receipt_payment
              );
              newData["data12"] =
                lineObj.dc_receipt_image === 1
                  ? "등록"
                  : lineObj.dc_receipt_image === -1
                  ? "없음"
                  : "미등록";
              newData["data13"] = lineObj.dc_prd_req_ton;
              newData["data14"] = lineObj.dc_prd_name;
              newData["data15"] = lineObj.dc_prd_quantity;
              newData["data16"] = lineObj.dc_volume;
              newData["data17"] = addThousandPoint(lineObj.dc_charge);
              newData["data18"] = addThousandPoint(lineObj.dc_rprice);
              newData["data19"] = lineObj.dc_prd_notice;
              newData["data20"] = lineObj.dc_prd_slip === 1 ? "Y" : "N";
              newData["data21"] = ChangeMobileFormat(lineObj.driver_mobile);
              newData["data22"] = ShowDeliveryStatus(lineObj.dc_status);
              newData["data23"] = lineObj.dc_admin_memo;
              newData["data24"] = lineObj.dc_idx;
              newData["data25"] = 0;
              newData["data26"] = lineObj.dc_reported === 0 ? "미신고" : "신고";
              newData["data27"] = addThousandPoint(lineObj.dc_dprice);
              newData["data28"] = lineObj.staff_name;
              newData["data29"] = lineObj.dc_paid === 1 ? "입금" : "미입금";
              newArray.push(newData);
            }
          }
          setDeliveryLists(newArray);
          setMaxNumPage(datas.totalcount - (varPageNum - 1) * varPageSize);
          setIsLoading(false);
        } else {
          setDeliveryLists([]);
          setTotalCount(0);
          setIsLoading(false);
        }
      });
  };

  //페이지 정보 변경시
  useEffect(() => {
    setMenuType("DELIVERY");
    setMenuItem("DeliveryList");

    //컬럼상태 설정
    //console.log(columnList,headerString);
    if (isNull(headerString)) {
      setColumnLists(columnList);
    } else {
      const headArray = headerString.split(",");
      let newColumnList = [];
      for (var i = 0; i < headArray.length; i++) {
        var headerItem = headArray[i];
        for (var j = 0; j < columnList.length; j++) {
          if (columnList[j].accessor === headerItem) {
            newColumnList.push(columnList[j]);
            break;
          }
        }
        //var datas = columnList.find(el=>el.accessor === headerItem);
      }
      setColumnLists(newColumnList);
    }
    const currentPage = localStorage.getItem("delivery_page");
    if (!isNull(currentPage)) setPageNum(currentPage);
    const currentPageSize = localStorage.getItem("delivery_page_size");
    if (!isNull(currentPageSize)) setPageSize(currentPageSize);
    const currentSearchData = localStorage.getItem("delivery_searchdata");
    if (!isNull(currentSearchData))
      setSearchData(JSON.parse(currentSearchData));

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  //페이지 정보 변경시
  useEffect(() => {
    localStorage.setItem("delivery_page", varPageNum);
    localStorage.setItem("delivery_page_size", varPageSize);
    localStorage.setItem("delivery_searchdata", JSON.stringify(varSearchData));
    if (varColumnLists?.length > 0) getDeliveryList();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [varPageNum, varSearchData, varColumnLists, varPageSize]);

  return (
    <div id="admin_contents" className="ad_contents">
      <HeaderTitle varMenuTitle="배차관리" varPageTitle="배차 현황" />
      <div className="admin-content">
        <DeliverySearch
          varSearchData={varSearchData}
          setSearchData={setSearchData}
          setPageNum={setPageNum}
        />
        {isLoading || varDeliveryLists?.length === 0 ? (
          <DeliverySearchEmptyResult />
        ) : (
          <DeliverySearchResult
            varTotalCount={varTotalCount}
            varColumnLists={varColumnLists}
            varMaxNumPage={varMaxNumPage}
            varPageSize={varPageSize}
            setPageSize={setPageSize}
            varDeliveryFee={varDeliveryFee}
            varDriverFee={varDriverFee}
            varDeliveryLists={varDeliveryLists}
            setDeliveryLists={setDeliveryLists}
            getDeliveryList={getDeliveryList}
            excelData={excelData}
          />
        )}
        <div className="paging" style={{ marginBottom: "20px" }}>
          <Paging
            totalCount={varTotalCount}
            pageSize={varPageSize}
            curPage={varPageNum}
            setPage={setPageNum}
          />
        </div>
      </div>
    </div>
  );
};
export default DeliveryList;
